import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=df248b46&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df248b46')) {
      api.createRecord('df248b46', component.options)
    } else {
      api.reload('df248b46', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=df248b46&", function () {
      api.rerender('df248b46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PSsnpjNJuLRb/JS/comp/ImgFallback.vue"
export default component.exports